import { css } from '@emotion/core';
import { typographyStyles } from '@newsela/angelou';

import { TABS } from './StandardsSelector';

const { heading5Obj } = typographyStyles;

export const $modalContentStyles = css`
  background-color: white;
  height: 88vh;
  margin: 0 64px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const $modalBody = (activeTab) => {
  return css`
overflow-y: scroll; 
flex: 1;
background-color: ${activeTab === TABS.REVIEW && '#F0F1F2'} 
`;
};

export const $conceptsNotFound = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
  max-width: fit-content;
  margin-top: 32px;
  }
  p {
  margin-top: 48px;
  ${heading5Obj};
  }
`;
